import { HistorialFacturacion } from '../interfaces/historial.interface'

export const historialInitialState: HistorialFacturacion = {
  searchFormFilter: {
    nit: '',
    tipoDocCliente: '',
    documento: '',
    nrcReceptor: '',
    nrcEmisor: '',
    nombreReceptor: '',
    fechaInicial: '',
    fechaFinal: '',
    tipoDTE: '',
  },
  formFilter: {
    nit: '',
    tipoDocCliente: '',
    documento: '',
    nrcReceptor: '',
    nrcEmisor: '',
    nombreReceptor: '',
    fechaInicial: '',
    fechaFinal: '',
    tipoDTE: '',
  },
  errorsFilter: {
    nit: '',
    tipoDocCliente: '',
    documento: '',
    nombreReceptor: '',
    nrcReceptor: '',
    nrcEmisor: '',
    fechaInicial: '',
    fechaFinal: '',
    tipoDTE: '',
  },
  activeFactura: null,
  anulado: false,
  resultAnulaciones: [],
  qrFactura: "",
  numPagina: 0,
  totalPaginas: 0,
  itemsAnular: [],
  arrayFacturas: [],
  tiposDocumentos: [],
  modals: {
    activeError: false,
    activeResult: false,
    activeOpciones: false,
    activeAnular: false,
    activeEnvioCorreo: false,
    activePrint: false,
    modoTicketPrint: false,
  },
}
